export enum ErrorsType{
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  InternalServerError = 500
}

export const ErrorsMessage: Record<ErrorsType, string> = {
  [ErrorsType.BadRequest]: 'Data validerings feil.',
  [ErrorsType.Unauthorized]: 'Du må autentisere deg på nytt.',
  [ErrorsType.Forbidden]: 'Du har ikke tilgang til registrene i Admin+.',
  [ErrorsType.InternalServerError]: 'Noe gikk galt.',
};
export interface ErrorMessageProps {
  open: boolean,
  onClose: () => void,
  error: string | Error,
}
